module.exports = "<router-outlet></router-outlet>\n<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\n"